import { render, staticRenderFns } from "./MascotAlert.vue?vue&type=template&id=b75656d0&scoped=true"
import script from "./MascotAlert.vue?vue&type=script&lang=ts"
export * from "./MascotAlert.vue?vue&type=script&lang=ts"
import style0 from "./MascotAlert.vue?vue&type=style&index=0&id=b75656d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75656d0",
  null
  
)

export default component.exports